module.exports = __webpack_public_path__ + "e1b044c2e3496837a843cdf6134b2e7f.MP3";